<template>
  <div id="asm">
    <div id="mainFixed1" class="mainFixed">
      <div class="pageTop">
        <div>
          <allSelect @on-change="brandChange" :disabled="brandList&&brandList.length>0?false:true" :chooseData="brandList" :needReturn="'Code'" :matchValue="'Name'" :showValue="'{{Name}}'" :state="'Status'" v-model="postData.brandCode" :width="'160px'">
          </allSelect>
          <span>&nbsp;&nbsp;{{$t('common.Year')}}：{{$commonJs.getMonthTh(month-1)>$commonJs.getMonthTh(month+3)?($commonJs.getMonthTh(month)==1?((parseInt(year)-1)+'~'+year):(year+'~'+(parseInt(year)+1))):year}}</span>
          <div class="m_l_20">
            <span class="m_l_10">{{$t('common.Keyword')}}：</span>
            <div>
              <input type="text" style="font-size: 12px;width: 125px;" class="allInput"
                     :placeholder="$t('common.TSNamePlaceholder')" v-model="postData.TSName" @keyup.enter="searchEvent()">
            </div>
            <div class="m_l_10">
              <button class="redButton" @click="searchEvent()">{{$t('common.Search')}}</button>
              <button class="cancelButtonRed m_l_10" @click="searchReset()">{{$t('common.Reset')}}</button>
            </div>
          </div>
        </div>
        <div>{{$t('common.YtdMsg'+$commonJs.getMonthTh(month))}}</div>
      </div>
      <div class="allSearch d_flex">
        <dl>
          <dd>
            <span class="f_w">{{$t('common.City')}}:</span>
            <div class="dis_line v_m">
              <allSelect @on-change="cityChange" :disabled="cityList&&cityList.length>0?false:true" :chooseData="cityList" :needReturn="'Code'" :matchValue="'Name'" :showValue="'{{Name}}'" v-model="postData.cityCode" :width="'100%'">
              </allSelect>
            </div>
          </dd>
          <dd>
            <span class="f_w">{{$t('common.Hospital')}}:</span>
            <div class="dis_line v_m">
              <hospitalSelect @submit="hospitalChange" :disabled="hospitalList&&hospitalList.length>0?false:true" :chooseData="hospitalList" :multiple="true" :needReturn="'Code'" :matchValue="'Name'" :showValue="'{{Name}}'" v-model="postData.hospitalCodes" :width="'100%'">
              </hospitalSelect>
            </div>
          </dd>
          <dt>
            <button class="redButton" @click="allReset()">{{$t('common.Reset')}}</button>
          </dt>
        </dl>
        <dl v-if="asmData.RejectInfo&&asmData.Status==$t('common.Draft')">
          <dt style="font-size:15px;white-space: normal;">
            <span class="colorRed">【{{$t('common.ReturnedComments')}}】</span><span>{{asmData.RejectInfo}}</span>
          </dt>
        </dl>
        <dl>
          <dt>
            <button v-if="!hideBtn&&postData.cityCode==''&&postData.hospitalCodes==''" class="greenButton" :disabled="asmData.Status==$t('common.Draft')?false:true" @click="submitData()"><i class="icon iconfont icon-tijiao"></i>{{$t('common.Submit')}}</button>
            <button v-if="!canEdit&&!hideBtn" :disabled="asmData.Status==$t('common.Draft')?false:true" class="redButton m_l_10" @click="editData()"><i class="icon iconfont icon-bianji"></i>{{$t('common.Edit')}}</button>
            <button v-if="canEdit&&!hideBtn" :disabled="asmData.Status==$t('common.Draft')?false:true" class="redButton m_l_10" @click="saveData()"><i class="icon iconfont icon-166991"></i>{{$t('common.Save')}}</button>
          </dt>
        </dl>
      </div>
      <table style="table-layout: fixed;" id="noScroll" class="allTable" cellspacing="0">
        <thead>
        <tr>
          <th class="w_20px">No.</th>
          <th>{{$t('common.City')}}</th>
          <th class="topNum"></th>
          <th>{{$t('common.Hospital')}}</th>
          <th>TS</th>
          <th>{{$t('common.'+$commonJs.getMonthTh(month-1)+'M')}}{{asmData.IsLastMonthSalesAcutal?$t('common.Sales'):$t('common.Forecast')}}</th>
          <th>{{$t('common.'+$commonJs.getMonthTh(month+0)+'M')}}{{$t('common.Forecast')}}</th>
          <th>{{$t('common.'+$commonJs.getMonthTh(month+1)+'M')}}{{$t('common.Forecast')}}</th>
          <th>{{$t('common.'+$commonJs.getMonthTh(month+2)+'M')}}{{$t('common.Forecast')}}</th>
          <th>{{$t('common.'+$commonJs.getMonthTh(month+3)+'M')}}{{$t('common.Forecast')}}</th>
          <th>{{$t('common.Submitter')}}</th>
          <th>{{$t('common.Status')}}</th>
        </tr>
        </thead>
        <tbody>
        <tr style="background-color: #F9F9F9;" class="colorRed f_w" v-if="asmData">
          <td></td>
          <td :key="'city' + index" v-for="(item, index) in cityList" v-if="item.Code===postData.cityCode">{{item.Name}}</td>
          <td class="topNum"></td>
          <td style="max-width: 200px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;">{{showHospitalName ? showHospitalName : $t('common.All')}}</td>
          <td></td>
          <td>{{$commonJs.numFixed(asmData.LastMonthSalesTotal)}}</td>
          <td>{{$commonJs.numFixed(asmData.CurrentMonthTotal)}}</td>
          <td>{{$commonJs.numFixed(asmData.SecondMonthTotal)}}</td>
          <td>{{$commonJs.numFixed(asmData.ThirdMonthTotal)}}</td>
          <td>{{$commonJs.numFixed(asmData.FourthMonthTotal)}}</td>
          <td>{{asmData.SubmittedBy}}</td>
          <td>{{hideBtn?'':asmData.Status}}</td>
        </tr>
        </tbody>
      </table>
    </div>
    <div class="mainScroll" :style="(showChartFlag?'margin-bottom: 288px;':'margin-bottom: 118px;')+'padding-top:'+mainScrollTop+'px'">
      <table style="table-layout: fixed;" class="allTable" cellspacing="0">
        <tbody>
          <tr :key="index" v-for="(item, index) in asmData.ForecastList" v-if="asmData.ForecastList&&asmData.ForecastList.length > 0" @dblclick="!canEdit&&!hideBtn&&asmData.Status==$t('common.Draft')?editData():''">
            <td class="w_20px">{{index+1}}</td>
            <td>{{item.CityName}}</td>
            <td class="topNum">{{item.Type}}</td>
            <td>
              <span @click="hospitalEvent(item)" class="greenA c_p">{{item.HospitalName}}</span>
            </td>
            <td><tsName :value="item.TSName" :key="item.TSName+Math.random()"></tsName></td>
            <td class="salesBorder">{{$commonJs.numFixed(item.LastMonthSalesAmount)}}</td>
            <td :class="canEdit?'editBC':''">
              <div :class="item.IsModifiedCurrentMonth?'bgRed':''" style="display: flex;justify-content: space-between;align-items: center;">
                <div style="display: flex;align-items: center;">
                  <editCom :canEdit="canEdit" :value="item.CurrentMonth" v-model="asmData.ForecastList[index].CurrentMonth"></editCom>
                  <i v-if="$commonJs.isShowHigh(item.LastMonthMinuTwoSalesAmount,item.LastMonthMinuOneSalesAmount,item.LastMonthSalesAmount,item.CurrentMonth)" class="icon iconfont icon-wanjiantou-"></i>
                  <i v-if="$commonJs.isShowLow(item.LastMonthMinuTwoSalesAmount,item.LastMonthMinuOneSalesAmount,item.LastMonthSalesAmount,item.CurrentMonth)" class="icon iconfont icon-wanjiantou"></i>
                </div>
                <reason v-model="asmData.ForecastList[index].Reasons.CurrentMonth" :canEdit="canEdit" @changeValue="changeReason"></reason>
              </div>
              <div :class="$commonJs.isShowHigh(item.LastMonthMinuTwoSalesAmount,item.LastMonthMinuOneSalesAmount,item.LastMonthSalesAmount,item.CurrentMonth)?'colorGreen':($commonJs.isShowLow(item.LastMonthMinuTwoSalesAmount,item.LastMonthMinuOneSalesAmount,item.LastMonthSalesAmount,item.CurrentMonth)?'colorRed':'')"
                   v-if="item.Reasons.CurrentMonth"><showReason v-model="item.Reasons.CurrentMonth"></showReason></div>
            </td>
            <td :class="canEdit?'editBC':''">
              <div :class="item.IsModifiedSecondMonth?'bgRed':''" style="display: flex;justify-content: space-between;align-items: center;">
                <div style="display: flex;align-items: center;">
                  <editCom :canEdit="canEdit" :value="item.SecondMonth" v-model="asmData.ForecastList[index].SecondMonth"></editCom>
                  <i v-if="$commonJs.isShowHigh(item.CurrentMonth,item.LastMonthMinuOneSalesAmount,item.LastMonthSalesAmount,item.SecondMonth)" class="icon iconfont icon-wanjiantou-"></i>
                  <i v-if="$commonJs.isShowLow(item.CurrentMonth,item.LastMonthMinuOneSalesAmount,item.LastMonthSalesAmount,item.SecondMonth)" class="icon iconfont icon-wanjiantou"></i>
                </div>
                <reason v-model="asmData.ForecastList[index].Reasons.SecondMonth" :canEdit="canEdit" @changeValue="changeReason"></reason>
              </div>
              <div :class="$commonJs.isShowHigh(item.CurrentMonth,item.LastMonthMinuOneSalesAmount,item.LastMonthSalesAmount,item.SecondMonth)?'colorGreen':($commonJs.isShowLow(item.CurrentMonth,item.LastMonthMinuOneSalesAmount,item.LastMonthSalesAmount,item.SecondMonth)?'colorRed':'')"
                   v-if="item.Reasons.SecondMonth"><showReason v-model="item.Reasons.SecondMonth"></showReason></div>
            </td>
            <td :class="canEdit?'editBC':''">
              <div :class="item.IsModifiedThirdMonth?'bgRed':''" style="display: flex;justify-content: space-between;align-items: center;">
                <div style="display: flex;align-items: center;">
                  <editCom :canEdit="canEdit" :value="item.ThirdMonth" v-model="asmData.ForecastList[index].ThirdMonth"></editCom>
                  <i v-if="$commonJs.isShowHigh(item.CurrentMonth,item.SecondMonth,item.LastMonthSalesAmount,item.ThirdMonth)" class="icon iconfont icon-wanjiantou-"></i>
                  <i v-if="$commonJs.isShowLow(item.CurrentMonth,item.SecondMonth,item.LastMonthSalesAmount,item.ThirdMonth)" class="icon iconfont icon-wanjiantou"></i>
                </div>
                <reason v-model="asmData.ForecastList[index].Reasons.ThirdMonth" :canEdit="canEdit" @changeValue="changeReason"></reason>
              </div>
              <div :class="$commonJs.isShowHigh(item.CurrentMonth,item.SecondMonth,item.LastMonthSalesAmount,item.ThirdMonth)?'colorGreen':($commonJs.isShowLow(item.CurrentMonth,item.SecondMonth,item.LastMonthSalesAmount,item.ThirdMonth)?'colorRed':'')"
                   v-if="item.Reasons.ThirdMonth"><showReason v-model="item.Reasons.ThirdMonth"></showReason></div>
            </td>
            <td :class="canEdit?'editBC':''">
              <div :class="item.IsModifiedFourthMonth?'bgRed':''" style="display: flex;justify-content: space-between;align-items: center;">
                <div style="display: flex;align-items: center;">
                  <editCom :canEdit="canEdit" :value="item.FourthMonth" v-model="asmData.ForecastList[index].FourthMonth"></editCom>
                  <i v-if="$commonJs.isShowHigh(item.CurrentMonth,item.SecondMonth,item.ThirdMonth,item.FourthMonth)" class="icon iconfont icon-wanjiantou-"></i>
                  <i v-if="$commonJs.isShowLow(item.CurrentMonth,item.SecondMonth,item.ThirdMonth,item.FourthMonth)" class="icon iconfont icon-wanjiantou"></i>
                </div>
                <reason v-model="asmData.ForecastList[index].Reasons.FourthMonth" :canEdit="canEdit" @changeValue="changeReason"></reason>
              </div>
              <div :class="$commonJs.isShowHigh(item.CurrentMonth,item.SecondMonth,item.ThirdMonth,item.FourthMonth)?'colorGreen':($commonJs.isShowLow(item.CurrentMonth,item.SecondMonth,item.ThirdMonth,item.FourthMonth)?'colorRed':'')"
                   v-if="item.Reasons.FourthMonth"><showReason v-model="item.Reasons.FourthMonth"></showReason></div>
            </td>
            <td>{{item.SubmittedBy}}</td>
            <td></td>
          </tr>
          <tr v-if="!asmData.ForecastList||asmData.ForecastList.length == 0">
            <td colspan="10" class="t_c colorGray bot_bottom">{{$t('common.noData')}}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div style="position: relative;height: 1px;"></div>
    <div class="chartArea" :class="showChartFlag?'show':'hide'">
      <button class="chartButton" @click="showChart()">{{showChartFlag?$t('common.Hide'):$t('common.Expand')}}</button>
      <div id="Charts"></div>
    </div>
    <dialogArea :show="showDialog" :width="'80%'" @cancel="submitCancel" @confirm="submitConfirm" :title="$t('common.Preview')">
      <div slot="content">
        <div v-if="isShowWarning" style="margin-top:-10px;margin-bottom: 15px;font-size:14px;text-align:center;padding:15px;font-weight:bold;border:1px solid #CC6A70;border-radius: 8px;background-color:#FFFFD9;color:#B62A40;">
          {{$t('common.DataSameMsg')}}
        </div>
        <div style="margin-top:-10px;margin-bottom: 15px;">{{$t('common.Brand')}}：{{this.brandName}}</div>
        <table class="dialogTable" cellspacing="0">
          <thead>
          <tr>
            <th>{{$t('common.'+$commonJs.getMonthTh(month+0)+'M')}}{{$t('common.Forecast')}}</th>
            <th>{{$t('common.'+$commonJs.getMonthTh(month+1)+'M')}}{{$t('common.Forecast')}}</th>
            <th>{{$t('common.'+$commonJs.getMonthTh(month+2)+'M')}}{{$t('common.Forecast')}}</th>
            <th>{{$t('common.'+$commonJs.getMonthTh(month+3)+'M')}}{{$t('common.Forecast')}}</th>
            <th>{{$commonJs.getLastQuarter(month)}}{{$t('common.QuarterTotal')}}*</th>
<!--            <th>{{$commonJs.getLastQuarter(month)}}{{$t('common.RateAndQoQ')}}</th>-->
            <th>{{$commonJs.getQuarter(month)}}{{$t('common.QuarterTotal')}}</th>
            <th>{{$commonJs.getQuarter(month)}}{{$t('common.RateAndQoQ')}}</th>
<!--            <th>{{$t('common.YTDRate')}}*</th>-->
          </tr>
          </thead>
          <tbody>
          <tr class="f_w">
            <td>{{$commonJs.numFixed(previewData.CurrentMonth)}}</td>
            <td>{{$commonJs.numFixed(previewData.SecondMonth)}}</td>
            <td>{{$commonJs.numFixed(previewData.ThirdMonth)}}</td>
            <td>{{$commonJs.numFixed(previewData.FourthMonth)}}</td>
            <td>{{$commonJs.numFixed(previewData.LastQuarterSales)}}</td>
<!--            <td>-->
<!--              <span v-if="previewData.LastQuarterCompletionRate==-1">&#45;&#45;</span>-->
<!--              <span v-else :class="previewData.LastQuarterCompletionRate<1?'colorYellow':''">{{Math.round(previewData.LastQuarterCompletionRate*100)}}%</span>-->
<!--              <span v-if="previewData.LastQuarterOnQuarterRatio==-1">(&#45;&#45;)</span>-->
<!--              <span v-else :class="previewData.LastQuarterOnQuarterRatio<0?'colorYellow':''">({{Math.round(previewData.LastQuarterOnQuarterRatio*100)}}%)</span>-->
<!--            </td>-->
            <td>{{$commonJs.numFixed(previewData.CurrentQuarterSales)}}</td>
            <td>
              <span v-if="previewData.CurrentQuarterCompletionRate==-1">--</span>
              <span v-else :class="previewData.CurrentQuarterCompletionRate<1?'colorYellow':''">{{Math.round(previewData.CurrentQuarterCompletionRate*100)}}%</span>
              <span v-if="previewData.QuarterOnQuraterRatio==-1">(--)</span>
              <span v-else :class="previewData.QuarterOnQuraterRatio<0?'colorYellow':''">({{Math.round(previewData.QuarterOnQuraterRatio*100)}}%)</span>
            </td>
<!--            <td>{{previewData.YTD==-1?'— —':Math.round(previewData.YTD*1000)/10+'%'}}</td>-->
          </tr>
          </tbody>
        </table>
      </div>
    </dialogArea>
  </div>
</template>

<script>
// let timePage
export default {
  name: 'asm',
  data () {
    return {
      postData: {
        brandCode: '',
        cityCode: '',
        hospitalCodes: '',
        TSName: ''
      },
      showHospitalName: '',
      chartHospitalName: '',
      brandName: '',
      brandList: [],
      cityList: [],
      asmData: false,
      hospitalList: [],
      chartData: [],
      previewData: [],
      canEdit: false,
      showChartFlag: true,
      showDialog: false,
      hideBtn: false,
      isShowWarning: true,
      year: new Date().getFullYear(),
      month: new Date().getMonth() + 1,
      mainScrollTop: 178
    }
  },
  beforeCreate () {
    this.$parent.topName = 'ASM'
  },
  created () {
    this.getBrandList()
  },
  destroyed () {
    window.removeEventListener('resize', this.resizeTable)
  },
  mounted () {
    this.$nextTick(() => {
      this.mainScrollTop = document.getElementById('mainFixed1').offsetHeight
      document.body.scrollTop = document.documentElement.scrollTop = 0
    })
    window.addEventListener('resize', this.resizeTable)
  },
  methods: {
    resizeTable () {
      this.mainScrollTop = document.getElementById('mainFixed1').offsetHeight
      this.$chart.chartResize()
    },
    getBrandList () {
      this.brandList = false
      this.$axiox.get('/api/v1/admin/brand/list').then(msg => {
        this.brandList = msg.data.BrandList || []
        let seltIndex = 0
        if (this.brandList && this.brandList.length > 0) {
          if (localStorage.brandCodeKey && localStorage.brandCodeKey !== '') {
            this.postData.brandCode = localStorage.brandCodeKey
          }
          this.brandList.forEach((e, i) => {
            if (e.Status === this.$t('common.Draft')) {
              this.brandList[i].state = true
            } else {
              this.brandList[i].state = false
            }
            if (this.postData.brandCode === e.Code) {
              seltIndex = i
            }
          })
          this.postData.brandCode = this.brandList[seltIndex].Code
          if (this.postData.brandCode.indexOf('_') !== -1) {
            this.hideBtn = true
          } else {
            this.hideBtn = false
          }
          localStorage.brandCodeKey = this.postData.brandCode
          this.brandName = this.brandList[seltIndex].Name
          this.year = this.brandList[seltIndex].Year
          this.month = this.brandList[seltIndex].Month
          this.getCityList()
        }
      })
    },
    getCityList () {
      this.postData.cityCode = ''
      let data = JSON.parse(JSON.stringify(this.postData))
      let url = this.$commonJs.returnQuery('/api/v1/admin/city/list', data)
      this.$axiox.get(url).then(msg => {
        this.cityList = msg.data || []
        if (this.cityList && this.cityList.length > 0) {
          this.cityList.unshift({Code: '', Name: this.$t('common.All')})
          this.postData.cityCode = this.cityList[0].Code
          this.getHospitalList()
        }
      })
    },
    getHospitalList () {
      this.postData.hospitalCodes = 'null'
      this.hospitalList = []
      let data = JSON.parse(JSON.stringify(this.postData))
      data.role = 'ASM'
      let url = this.$commonJs.returnQuery('/api/v1/admin/hospital/list', data)
      this.$axiox.get(url).then(msg => {
        this.postData.hospitalCodes = ''
        if (msg.data && msg.data.length > 0) {
          msg.data.unshift({Code: '', Name: this.$t('common.All')})
          this.hospitalList = msg.data || []
          this.showHospitalName = this.$t('common.All')
          this.chartHospitalName = this.$t('common.All')
          this.getAsmList()
        }
      })
    },
    searchEvent () {
      this.asmData = false
      this.getAsmList()
      this.chartHospitalName = this.showHospitalName
    },
    searchReset () {
      this.postData.TSName = ''
      this.asmData = false
      this.getAsmList()
      this.chartHospitalName = this.showHospitalName
    },
    getAsmList () {
      this.canEdit = false
      let data = JSON.parse(JSON.stringify(this.postData))
      let url = this.$commonJs.returnQuery('/api/v1/admin/asmForecast/list', data)
      this.$axiox.get(url).then(msg => {
        if (msg.data && msg.data.ForecastList && msg.data.ForecastList.length > 0) {
          msg.data.ForecastList.forEach((val, i) => {
            msg.data.ForecastList[i].Reasons = {
              CurrentMonth: {ReasonCode: val.CurrentMonthReasonCode, Comment: val.CurrentMonthComment, ShowReason: this.getShowReason(val.CurrentMonthReasonCode)},
              SecondMonth: {ReasonCode: val.SecondMonthReasonCode, Comment: val.SecondMonthComment, ShowReason: this.getShowReason(val.SecondMonthReasonCode)},
              ThirdMonth: {ReasonCode: val.ThirdMonthReasonCode, Comment: val.ThirdMonthComment, ShowReason: this.getShowReason(val.ThirdMonthReasonCode)},
              FourthMonth: {ReasonCode: val.FourthMonthReasonCode, Comment: val.FourthMonthComment, ShowReason: this.getShowReason(val.FourthMonthReasonCode)}
            }
          })
        }
        this.asmData = msg.data || {}
        this.$nextTick(() => {
          this.mainScrollTop = document.getElementById('mainFixed1').offsetHeight
          document.body.scrollTop = document.documentElement.scrollTop = 0
        })
        this.getChartData()
      })
    },
    getPreviewList () {
      let data = JSON.parse(JSON.stringify(this.postData))
      let url = this.$commonJs.returnQuery('/api/v1/admin/asmForecast/preview', data)
      this.$axiox.get(url).then(msg => {
        this.previewData = msg.data || {}
        this.showDialog = true
      })
    },
    getChartData (hospitalCode) {
      let data = JSON.parse(JSON.stringify(this.postData))
      if (hospitalCode) {
        data.hospitalCodes = hospitalCode
      }
      let url = this.$commonJs.returnQuery('/api/v1/admin/chartdata', data)
      this.$axiox.get(url).then(msg => {
        if (msg.data) {
          let datas = {}
          let monthList = []
          let actualList = []
          let forecastList = []
          let targetList = []
          let completionList = []
          if (msg.data.ActualSalesAndForecastList && msg.data.ActualSalesAndForecastList.length > 0) {
            msg.data.ActualSalesAndForecastList.forEach((a, i) => {
              monthList.push(a.YearMonth)
              if (i < 6) {
                actualList.push(a.Value)
                forecastList.push(null)
              } else {
                actualList.push(null)
                forecastList.push(a.Value)
              }
            })
          }
          if (msg.data.TargetList && msg.data.TargetList.length > 0) {
            msg.data.TargetList.forEach((a, i) => {
              targetList.push(a.Value)
            })
          }
          if (msg.data.CompletionPercentageList && msg.data.CompletionPercentageList.length > 0) {
            msg.data.CompletionPercentageList.forEach(a => {
              if (a.Value != null) {
                completionList.push(Math.round(a.Value * 1000) / 10)
              } else {
                completionList.push(null)
              }
            })
          }
          datas.monthList = monthList
          datas.actualList = actualList
          datas.forecastList = forecastList
          datas.targetList = targetList
          datas.completionList = completionList
          this.chartData = datas
          if (this.chartHospitalName.indexOf(',') !== -1) {
            let hNameArr = this.chartHospitalName.split(',')
            if (hNameArr.length > 3) {
              this.chartHospitalName = hNameArr[0] + '，' + hNameArr[1] + '，' + hNameArr[2] + '...'
            }
          }
          this.$chart.asmChart('Charts', this.brandName + '-' + this.asmData.TerritoryName + '-' + this.chartHospitalName, this.chartData)
        }
      })
    },
    saveAsmList () {
      let data = this.asmData.ForecastList
      let flag = true
      data.forEach((val, i) => {
        data[i].CurrentMonthReasonCode = val.Reasons.CurrentMonth.ReasonCode
        data[i].CurrentMonthComment = val.Reasons.CurrentMonth.ReasonCode !== 6 && val.Reasons.CurrentMonth.ReasonCode !== 7 ? val.Reasons.CurrentMonth.Comment : ''
        data[i].SecondMonthReasonCode = val.Reasons.SecondMonth.ReasonCode
        data[i].SecondMonthComment = val.Reasons.SecondMonth.ReasonCode !== 6 && val.Reasons.SecondMonth.ReasonCode !== 7 ? val.Reasons.SecondMonth.Comment : ''
        data[i].ThirdMonthReasonCode = val.Reasons.ThirdMonth.ReasonCode
        data[i].ThirdMonthComment = val.Reasons.ThirdMonth.ReasonCode !== 6 && val.Reasons.ThirdMonth.ReasonCode !== 7 ? val.Reasons.ThirdMonth.Comment : ''
        data[i].FourthMonthReasonCode = val.Reasons.FourthMonth.ReasonCode
        data[i].FourthMonthComment = val.Reasons.FourthMonth.ReasonCode !== 6 && val.Reasons.FourthMonth.ReasonCode !== 7 ? val.Reasons.FourthMonth.Comment : ''
      })
      if (flag) {
        this.$axiox.put('/api/v1/admin/asmForecast', data).then(msg => {
          this.$commonJs.alertTips({
            type: 'success',
            content: this.$t('common.SaveSuccess'),
            stayTime: 5
          })
          // this.asmData = false
          this.getAsmList()
        })
      }
    },
    submitAsmList () {
      let data = JSON.parse(JSON.stringify(this.postData))
      this.$axiox.put('/api/v1/admin/asmForecast/submit', data).then(msg => {
        this.$commonJs.alertTips({
          type: 'success',
          content: this.$t('common.SubmitSuccess'),
          stayTime: 5
        })
        this.brandList = false
        this.getBrandList()
      })
    },
    submitConfirm () {
      this.showDialog = false
      this.submitAsmList()
    },
    submitCancel () {
      this.showDialog = false
    },
    brandChange (data) {
      this.brandName = data.Name
      this.year = data.Year
      this.month = data.Month
      this.asmData = false
      localStorage.brandCodeKey = this.postData.brandCode
      if (this.postData.brandCode.indexOf('_') !== -1) {
        this.hideBtn = true
      } else {
        this.hideBtn = false
      }
      this.getCityList()
    },
    cityChange () {
      this.asmData = false
      this.getHospitalList()
    },
    hospitalChange (data) {
      this.showHospitalName = data
      this.chartHospitalName = data
      this.asmData = false
      this.getAsmList()
    },
    changeReason (data) {
    },
    hospitalEvent (data) {
      // this.postData.hospitalCodes = data.HospitalCode
      // this.showHospitalName = data.HospitalName
      this.chartHospitalName = data.HospitalName
      this.getChartData(data.HospitalCode)
    },
    editData () {
      this.canEdit = true
    },
    saveData () {
      setTimeout(() => {
        let inputList = document.querySelectorAll('.sales_input')
        if (inputList && inputList.length > 0) {
          return false
        }
        this.saveAsmList()
      }, 50)
    },
    submitData () {
      if (this.canEdit) {
        this.$commonJs.alertTips({
          type: 'error',
          content: this.$t('common.NoSaveMsg'),
          stayTime: 5
        })
      } else {
        let data = this.asmData.ForecastList
        let flag = true
        if (data && data.length > 0) {
          data.forEach((val, i) => {
            // if (this.checkReason(val.LastMonthMinuTwoSalesAmount, val.LastMonthMinuOneSalesAmount, val.LastMonthSalesAmount, val.CurrentMonth, val.Reasons.CurrentMonth.ReasonCode, i, val.HospitalName)) {
            //   flag = false
            // } else if (this.checkReason(val.CurrentMonth, val.LastMonthMinuOneSalesAmount, val.LastMonthSalesAmount, val.SecondMonth, val.Reasons.SecondMonth.ReasonCode, i, val.HospitalName)) {
            //   flag = false
            // } else if (this.checkReason(val.CurrentMonth, val.SecondMonth, val.LastMonthSalesAmount, val.ThirdMonth, val.Reasons.ThirdMonth.ReasonCode, i, val.HospitalName)) {
            //   flag = false
            // } else if (this.checkReason(val.CurrentMonth, val.SecondMonth, val.ThirdMonth, val.FourthMonth, val.Reasons.FourthMonth.ReasonCode, i, val.HospitalName)) {
            //   flag = false
            // }
            if (val.FourthMonth !== val.ThirdMonth) {
              this.isShowWarning = false
            }
          })
        }
        if (flag) {
          this.canEdit = false
          this.getPreviewList()
        }
      }
    },
    allReset () {
      this.asmData = false
      this.postData.cityCode = ''
      this.postData.hospitalCodes = ''
      this.showHospitalName = this.$t('common.All')
      this.chartHospitalName = this.$t('common.All')
      this.getHospitalList()
    },
    showChart () {
      if (this.showChartFlag) {
        this.showChartFlag = false
      } else {
        this.showChartFlag = true
      }
    },
    getShowReason (rCode) {
      switch (rCode) {
        case '1':
          return this.$t('common.Reason1')
        case '2':
          return this.$t('common.Reason2')
        case '3':
          return this.$t('common.Reason3')
        case '4':
          return this.$t('common.Reason4')
        case '5':
          return this.$t('common.Reason5')
        case '6':
          return this.$t('common.Reason6')
        case '7':
          return this.$t('common.Reason7')
      }
    },
    checkReason (before1, before2, before3, current, reasonCode, rowNum, hospitalName) {
      if ((this.$commonJs.isShowHigh(before1, before2, before3, current) || this.$commonJs.isShowLow(before1, before2, before3, current)) && (reasonCode === '' || reasonCode === null || reasonCode === undefined)) {
        this.$commonJs.alertTips({
          type: 'error',
          content: this.$t('common.AsmReasonCheck', {'rowNum': (rowNum + 1), 'hospitalName': hospitalName}),
          stayTime: 5
        })
        return true
      } else {
        return false
      }
    }
  }
}
</script>

<style scoped>
  .allTable tbody tr:nth-child(2n) {
    background-color: #F8F8F8;
  }
  .salesBorder{
    border-left: 1px solid #f4d0d9;
    border-right: 1px dashed #f4d0d9;
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/gileadSales/asm.vue